import request from '@/_helpers/requests/requestNotif'

export const modelService = {
    getModelData() {
        return new Promise((resolve) => {
    
            request.get('model145/data').then(response => {
                resolve(response.data)
            });
        });
    },
    getModelDataModify() {
        return new Promise((resolve) => {
    
            request.get('model145/dataModify').then(response => {
                resolve(response.data)
            });
        });
    },
    getUserData() {
        return new Promise((resolve) => {
    
            request.get('model145/user').then(response => {
                resolve(response.data)
            });
        });
    },
    getAscendienteData(anoNotificacion) {
        return new Promise((resolve) => {
    
            request.get('model145/ascendientes/' + anoNotificacion).then(response => {
                resolve(response.data)
            });
        });
    },
    getDescendienteData(anoNotificacion) {
        return new Promise((resolve) => {
    
            request.get('model145/descendientes/' + anoNotificacion).then(response => {
                resolve(response.data)
            });
        });
    },
    postModelData(postData) {
        return new Promise((resolve) => {
    
            request.post('model145', postData).then(response => {
                resolve(response);
            });
        });
    },
};